import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";

// Monthly sales targets for the Daily Trading Report. Store-scoped routes
// (F1): the active store's owner / store admin set the store target and any
// rep's, a rep sets their own, RC master any (SalesTargetController::*Scoped).
// Amounts are pence (×100) over the wire — components convert to/from pounds.

export const useStoreTarget = (storeId) => {
  const qc = useQueryClient();

  const query = useQuery({
    queryKey: ["store-monthly-target", storeId],
    queryFn: async () => {
      const res = await axios.get(`/api/stores/${storeId}/monthly-targets`);
      return res?.data || {};
    },
    enabled: !!storeId,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  const mutation = useMutation({
    mutationFn: (payload) =>
      axios.put(`/api/stores/${storeId}/monthly-targets`, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["store-monthly-target", storeId] }),
  });

  return { target: query.data, isLoading: query.isLoading, save: mutation.mutate, isSaving: mutation.isLoading };
};

export const useRepTarget = (userId) => {
  const qc = useQueryClient();

  const query = useQuery({
    queryKey: ["rep-monthly-turnover-target", userId],
    queryFn: async () => {
      const res = await axios.get(`/api/users/${userId}/monthly-turnover-target`);
      return res?.data || {};
    },
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  const mutation = useMutation({
    mutationFn: (payload) =>
      axios.put(`/api/users/${userId}/monthly-turnover-target`, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["rep-monthly-turnover-target", userId] }),
  });

  return { target: query.data, isLoading: query.isLoading, save: mutation.mutate, isSaving: mutation.isLoading };
};
